import { render, staticRenderFns } from "./FrontierTourSettings.vue?vue&type=template&id=31f6c7d8&scoped=true"
import script from "./FrontierTourSettings.vue?vue&type=script&lang=js"
export * from "./FrontierTourSettings.vue?vue&type=script&lang=js"
import style0 from "./FrontierTourSettings.vue?vue&type=style&index=0&id=31f6c7d8&prod&lang=scss&scoped=true"
import style1 from "./FrontierTourSettings.vue?vue&type=style&index=1&id=31f6c7d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6c7d8",
  null
  
)

export default component.exports